import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subject, catchError, map, Observable, throwError } from 'rxjs';
import {
    AddCererePayload,
    EditCererePayload,
    extraActionCererePayload,
    EditRequestStatusPayload,
    EditRequestPriorityPayload,
    EditRequestAssigneePayload,
    UpdateMassStatusPayload,
    UpdateMassAssignPayload,
} from './request.interface';

@Injectable({
    providedIn: 'root',
})
export class RequestsService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getRequestsDTURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.getCereriListDT;
    private getInfoDocListURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.getInfoDocList;
    private storeRequestsURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.storeCereri;
    private updateRequestURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.updateCereri;
    private deleteRequestURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.deleteCereri;

    private rePostMessageURL =
        this.basePath + environment.interop.platform.nomenclatoare.cereri.rePostMessage;

    private resetValidareCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.cereri.resetValidareCerere;

    private resetinValidareCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.cereri.resetinValidareCerere;

    private resetClasareCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.cereri.resetClasareCerere;

    private resetInchidereCerereUrl =
        this.basePath + environment.interop.platform.nomenclatoare.cereri.resetInchidereCerere;

    // Vizualizare solicitare

    private validateCerereUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.validateCerere;
    private invalidateCerereUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.invalidateCerere;
    private cancellationCerereUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.cancellationCerere;
    private preluareCerereUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.preluareCerere;
    private postMessageUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.postMessage;
    private updatePriorityUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.updatePriority;
    private updateStatusUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.updateStatus;
    private updateAssigneeURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.updateAssignee;
    public downloadDocumentUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.getDocument;
    private fileUploadUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.uploadFileRegister;

    private getHistoryByIdUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereriHistory
            .getCerereHistoryByCerereId;

    private exportHistoryUrl = this.basePath + environment.interop.platform.nomenclatoare.cereri.exportHistory;
    // Compartimente

    private getCompartimenteByDirectieUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.compartiment
            .getCompartimenteByDirectie;

    private getCompartimenteActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.compartiment
            .getCompartimenteActive;

    // Directii

    private getDirectiiActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.directie.getDirectiiActive;
    // Mass update & assign

    private massUpdateStatusURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.massUpdateStatus;

    private massAssignURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.massAssign;

    private numarRegistraturaURL =
        this.basePath +
        environment.interop.platform.nomenclatoare.cereri.numarRegistratura;

    private updatePhoneNumberSolicitareURL = 
        this.basePath + 
        environment.interop.platform.nomenclatoare.cereri.updatePhoneNumberSolicitare

    private sablonContent = new Subject<string>();
    sablonContent$ = this.sablonContent.asObservable();

    constructor(private http: HttpClient) { }

    preluareNumarRegistratura(id: number) {
        return this.http.get(this.numarRegistraturaURL + id, this.httpOptions);
    }

    getRequestsDT() {
        return this.http.get(this.getRequestsDTURL, this.httpOptions);
    }

    addRequest(request: AddCererePayload) {
        return this.http.post(this.storeRequestsURL, request, this.httpOptions);
    }

    updateRequest(request: EditCererePayload) {
        return this.http.put(this.updateRequestURL, request, this.httpOptions);
    }

    deleteRequest(id: number) {
        return this.http.delete(this.deleteRequestURL + id);
    }

    getInfoDocList(id: number) {
        return this.http.get(this.getInfoDocListURL + id);
    }

    preluareCerere(cerereId: number) {
        return this.http.post(this.preluareCerereUrl + cerereId, this.httpOptions);
    }

    validateCerere(id: number) {
        return this.http.get(this.validateCerereUrl + id);
    }

    invalidateCerere(data: extraActionCererePayload) {
        return this.http.post(this.invalidateCerereUrl, data, this.httpOptions);
    }

    anulareCerere(data: extraActionCererePayload) {
        return this.http.post(this.cancellationCerereUrl, data, this.httpOptions);
    }

    postMessage(id: number, message: any) {
        return this.http.post(
            this.postMessageUrl,
            { ...message, id_cerere: id },
            this.httpOptions
        );
    }

    updateRequestStatus(status: EditRequestStatusPayload) {
        return this.http.post(this.updateStatusUrl, status, this.httpOptions);
    }

    updateRequestPriority(priority: EditRequestPriorityPayload) {
        return this.http.post(this.updatePriorityUrl, priority, this.httpOptions);
    }

    updateRequestAssignee(data: EditRequestAssigneePayload) {
        return this.http.post(this.updateAssigneeURL, data, this.httpOptions);
    }

    getHistoryById(id: number) {
        return this.http.get(this.getHistoryByIdUrl + id, this.httpOptions);
    }

    fileUpload(formData: FormData) {
        return this.http.post<{ data: any }>(this.fileUploadUrl, formData);
    }

    getCompartimenteByDirectieId(id: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteByDirectieUrl + id
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in getCompartimenteByDirectieId:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente active:', error);
                    return throwError(error);
                })
            );
    }

    getDirectii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDirectiiActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get directii active:', error);
                    return throwError(error);
                })
            );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    updateMassStatus(data: UpdateMassStatusPayload) {
        return this.http.post(this.massUpdateStatusURL, data, this.httpOptions);
    }

    updateMassAssign(data: UpdateMassAssignPayload) {
        return this.http.post(this.massAssignURL, data, this.httpOptions);
    }

    sendContent(content: string) {
        this.sablonContent.next(content);
    }

    rePostMessage(id: number) {
        return this.http.post(this.rePostMessageURL + id, this.httpOptions);
    }

    exportHistory(cerere_id: number, user_type: number): Observable<Blob> {
        return this.http.get(this.exportHistoryUrl + cerere_id + '/' + user_type, {
            responseType: 'blob',
        });
    }

    updatePhoneNumberSolicitare(cerereId : number, data: any) {
        return this.http.post(this.updatePhoneNumberSolicitareURL + cerereId, data, this.httpOptions);
    }

    resetValidareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetValidareCerereUrl + cerereId, data);
    }

    resetinValidareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetinValidareCerereUrl + cerereId, data);
    }

    resetClasareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetClasareCerereUrl + cerereId, data);
    }

    resetInchidereCerere(cerereId: number, data: any) {
        return this.http.post(this.resetInchidereCerereUrl + cerereId, data);
    }
}
